import { logger } from "./logger";

export async function fetchDirectLineToken(directlineTokenUrl: string): Promise<string | null> {
  try {
    logger.debug("[Chatbot] Fetching Direct Line token from:", directlineTokenUrl);

    const response = await fetch(directlineTokenUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    logger.debug("[Chatbot] Direct Line response status:", response.status);

    if (!response.ok) {
      logger.error(`[Chatbot] Failed to fetch token. Status: ${response.status} ${response.statusText}`);
      const errorText = await response.text();
      logger.error("[Chatbot] Error response:", errorText);
      return null;
    }

    const data = await response.json();
    logger.debug("[Chatbot] Direct Line token received successfully");
    return data.token ?? null;
  } catch (error) {
    logger.error("[Chatbot] Failed to fetch Direct Line token:", error);
    return null;
  }
}
